import { APP_BASE_HREF } from '@angular/common';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs';

function strip(str: string, char: string): string {
  return str.replace(new RegExp(`^${char}+|${char}+$`, 'g'), '');
}

function rstrip(str: string, char: string): string {
  return str.replace(new RegExp(`${char}+$`), '');
}

function lstrip(str: string, char: string): string {
  return str.replace(new RegExp(`^${char}+`), '');
}

@Injectable({
  providedIn: 'root'
})

export class AppService {  
  private openGdprDialogCaller = new Subject<any>();
  private openLegalNoticeDialogCaller = new Subject<any>();
  
  openGdprDialogCalled$ = this.openGdprDialogCaller.asObservable();
  openLegalNoticeDialogCalled$ = this.openLegalNoticeDialogCaller.asObservable();  

  constructor(
    @Inject(APP_BASE_HREF) private _baseHref: string
  ) {
  }

  callOpenGdprDialog() {
    this.openGdprDialogCaller.next();
  }

  callOpenLegalNoticeDialog() {
    this.openLegalNoticeDialogCaller.next();
  }

  baseHref(): string {
    return `/${strip(this._baseHref, '/')}`;
  }

  rootRelative(s: string): string {
    return `${rstrip(this.baseHref(), '/')}/${lstrip(s, '/')}`;
  }  
}